export const THROTTLE_INTERVAL = 10;
export const CARD_OFFSET = 7.5;

export const DEFAULT_FA_ICONS = [
  'chart-bar',
  'database',
  'user',
  ['bag-shopping', 'shopping-bag'],
  'layer-group',
  'receipt',
  'sack-dollar',
  'browser',
  ['calendar-days', 'calendar-alt'],
  ['book-blank', 'book-alt'],
  'form-entity', // custom
  'survey-entity', // custom
  'mcp-entity', // custom
  'brackets-curly',
  'user-doctor',
  'stethoscope',
  'prescription',
  'prescription-bottle',
  'prescription-bottle-alt',
  'pills',
  'notes-medical',
  'id-card-alt',
  'hospital',
  'procedures',
  'clipboard-prescription',
  'file-medical',
  'file-medical-alt',
  'diagnoses',
  'clinic-medical',
  'clipboard-list',
  ['bullseye-arrow', 'bullseye-pointer'],
  'play',
  ['gear', 'cog'],
  ['circle-user', 'user-circle'],
  'repeat',
  ['plus', 'add'],
  ['right-from-bracket', 'sign-out'],
  ['circle-question', 'question-circle'],
  'graduation-cap',
  'comments',
  'kizen-k',
  ['external-link', 'toolbar-external-link'],
  'bars-light',
  'house',
  'arrows-to-circle',
  'store',
  'history',
  'books',
  'bell',
  'arrow-progress',
  'code',
];
